import { render, staticRenderFns } from "./return-orders.vue?vue&type=template&id=85ac3c98&scoped=true&lang=pug"
import script from "./return-orders.vue?vue&type=script&lang=js"
export * from "./return-orders.vue?vue&type=script&lang=js"
import style0 from "./return-orders.vue?vue&type=style&index=0&id=85ac3c98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ac3c98",
  null
  
)

export default component.exports